import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { CartService } from 'src/app/services/cart.service';
import { PopoverController, LoadingController, AlertController, MenuController } from '@ionic/angular';
import { CartPage } from 'src/app/pages/cart/cart.page';
import { ServicioService } from 'src/app/services/servicio.service';
import { FlagsPage } from 'src/app/pages/flags/flags.page';
import { Router } from '@angular/router';

@Component({
  selector: 'app-cartComponent',
  templateUrl: './cart.component.html'
})
export class CartComponent implements OnInit {
  //   @ViewChild('flag', { static: true }) bandera: ElementRef;

  hasData = false;
  items: any = [];
  productos: any = [];
  productRows: any;

  cartItems: any[];
  public countCart = 0;

  searchVisible = false;

  public pais = 'co';
  public flag = '';
  public visible = true;

  constructor(
    private menu: MenuController,
    private cart: CartService,
    private popoverCtrl: PopoverController,
    private loadingCtrl: LoadingController,
    private alertCtrl: AlertController,
    private service: ServicioService,
    private router: Router
  ) {

    this.items = [];
    this.productos = [];
    this.productRows = null;

  }

  ngOnInit() {

    this.service.getObservableCart().subscribe((data) => {

      this.actualizarCarro();

    });

    // this.actualizarCarro();

  }

  ionViewWillEnter() {
    // this.actualizarCarro();
  }

  async actualizarCarro() {
    await this.cart.getCartItems().then((val) => {
      this.cartItems = val;
    });

    await this.cart.getCountItems().then((val) => {
      this.countCart = val;
    });
  }

  async mostrarCarro() {

    const popover = await this.popoverCtrl.create({
      component: CartPage,
      animated: true,
      translucent: true
    });

    popover.onDidDismiss().then(async res => {
      this.actualizarCarro();
    });

    return await popover.present();

  }

}
